import { ArtistMinifiedType } from '@api';
import { ActionsCell, PersonAnchor } from '@common';
import { DataTableColumn } from 'mantine-datatable';
import { useTranslation } from 'react-i18next';

const TRANS_PATH = 'TABLE.COLUMNS';

type UseArtistsOverviewTableColumnsProps = {
  handleDeleteArtist: (record: ArtistMinifiedType) => void;
};

type UseArtistsOverviewTableColumnsReturnType = {
  columns: DataTableColumn<ArtistMinifiedType>[];
};

export const useArtistsOverviewTableColumns = ({
  handleDeleteArtist,
}: UseArtistsOverviewTableColumnsProps): UseArtistsOverviewTableColumnsReturnType => {
  const { t } = useTranslation('artists');

  const noDataPlaceholder = t('NO_DATA_PLACEHOLDER', { ns: 'common' });

  const columns: DataTableColumn<ArtistMinifiedType>[] = [
    {
      accessor: 'name',
      title: t(`${TRANS_PATH}.NAME`),
      sortable: true,
    },
    {
      accessor: 'agent.name',
      title: t(`${TRANS_PATH}.AGENT`),
      render: ({ agent }) =>
        agent ? <PersonAnchor person={agent} /> : noDataPlaceholder,
    },
    {
      accessor: 'buyer.name',
      title: t(`${TRANS_PATH}.BUYER`),
      render: ({ buyer }) =>
        buyer ? <PersonAnchor person={buyer} /> : noDataPlaceholder,
    },
    {
      accessor: 'manager.name',
      title: t(`${TRANS_PATH}.MANAGER`),
      render: ({ manager }) =>
        manager ? <PersonAnchor person={manager} /> : noDataPlaceholder,
    },
    {
      accessor: 'projectLead.name',
      title: t(`${TRANS_PATH}.PROJECT_LEAD`),
      render: ({ projectLead }) =>
        projectLead ? <PersonAnchor person={projectLead} /> : noDataPlaceholder,
    },
    {
      accessor: 'coordinator.name',
      title: t(`${TRANS_PATH}.COORDINATOR`),
      render: ({ coordinator }) =>
        coordinator ? <PersonAnchor person={coordinator} /> : noDataPlaceholder,
    },
    {
      accessor: 'actions',
      title: t(`${TRANS_PATH}.ACTIONS`),
      titleStyle: { textAlign: 'center' },
      render: (record) => (
        <ActionsCell.Root>
          <ActionsCell.Details to={`/artists/${record.id}`} />
          <ActionsCell.Delete onClick={() => handleDeleteArtist(record)} />
        </ActionsCell.Root>
      ),
      width: 100,
    },
  ];

  return { columns };
};
